import { render, staticRenderFns } from "./ClaimsCheck.vue?vue&type=template&id=1e910b6a&scoped=true"
import script from "./ClaimsCheck.vue?vue&type=script&lang=ts"
export * from "./ClaimsCheck.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsCheck.vue?vue&type=style&index=0&id=1e910b6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e910b6a",
  null
  
)

export default component.exports